import { render, staticRenderFns } from "./SendInfoMotiveDialog.vue?vue&type=template&id=462442a2&"
import script from "./SendInfoMotiveDialog.vue?vue&type=script&lang=js&"
export * from "./SendInfoMotiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports